import camelcaseKeys from "camelcase-keys";

export async function getData(url) {
  let response;
  try {
    response = await fetch(url);
  } catch (error) {
    console.log("Could not load", error);
    throw new Error("Could not load", url);
  }
  if (response.status !== 200) {
    throw new Error("Not found", url);
  }
  try {
    const data = await response.json();
    return camelcaseKeys(data, { deep: true });
  } catch (error) {
    console.log("Could not parse", error);
    throw new Error("Could not parse", url);
  }
}
